import cleanedFilename from '~/util/cleanedFilename';

export default {
  NEXT_STEP_BUTTON: `${cleanedFilename(__filename)}-next-step-button`,
  GO_BACK_BUTTON: `${cleanedFilename(__filename)}-go-back-button`,
};
